<div>
	<app-face-capture (continue)="next($event)" (back)="back.emit()" [error]="errorMessage" [submitting]="submitting">
	</app-face-capture>
</div>